module.exports = __webpack_public_path__ + "static/handbook_editor-c982a3b2415723df64dd0c22e8dabd60.webp";